/**
 * Created by agengmaulana on 2/9/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import Comment_Profile_Image from '../comment_profile_image/comment_profile_image'
import Comment_Username from '../comment_username/comment_username'
import Comment_Like_Button from '../comment_like_button/comment_like_button'
import Comment_Reply_Button from '../comment_reply_button/comment_reply_button'
import Comment_Report_Abuse from '../comment_report_abuse/comment_report_abuse'
import Comment_Share from '../comment_share/comment_share'
import Comment_Form from './../comment_form/comment_form'
import Comment_Moderation from './../comment_moderation/comment_moderation'
import unescapeJs from 'unescape-js'
// import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import {observer} from "mobx-react"
import {observable} from "mobx"


@observer
export default class Comment_Child_Row extends React.Component {

    @observable dispParent = false
    @observable mod = false

    constructor(props) {
        super(props);
    }
    render() {
        const {dataStore,uaBreak,datastoresVerified} = this.props;
        let anchorhighlightchild = this.props.id === dataStore.anchor ? styles.cmt_highlight : ''
        const divelement = <div key={this.props.id} id={this.props.id}>
            <Comment_Profile_Image mr10="false" photo={this.props.image} nickname={this.props.nickname}/>
            { this.props.pilihanredaksi == true ?
                < div className={styles.cmt_label_pilred+' '+styles.cmt_fr}>
                    <i className={styles.icon+' dk_icon-check-square cmt_check'}></i> Komentar Pilihan
                </div> : ''
            }
            <Comment_Username mb10="false" nickname={this.props.nickname} create_date={this.props.create_date} verified_user={typeof datastoresVerified[this.props.uniqueid] !== 'undefined'?datastoresVerified[this.props.uniqueid]:false}/>

            <div className={styles.cmt_box_text+' '+styles.cmt_dk_komen} style={{wordBreak:uaBreak}}>
                <div data-icon="i" className="icon"> <a href="javascript:void(0);" className={styles.cmt_href} onClick={this.toanchor}><span className={styles.cmt_dk_name}> {this.props.refer.name}</span></a> {unescape(this.props.content)}</div>
                {this.props.mod ? null :
                    <div className={styles.cmt_dk_action} >
                        <Comment_Report_Abuse isMobile={this.props.isMobile}  id={this.props.id} status_lapor={this.props.status_lapor} datFunction={dataStore} />

                        <Comment_Like_Button isMobile={this.props.isMobile}  like={this.props.like} status_like={this.props.status_like} parent_id={this.props.parent_id} id={this.props.id} dataStore={dataStore} />
                        <Comment_Reply_Button toggle={this.OpenForm}  textreply={this.dispParent} idButton={this.props.id}/>
                        Bagikan:    <Comment_Share content={this.props.content} id={this.props.id} datFunction={dataStore} />
                    </div>
                }
            </div>
                {this.dispParent ? <Comment_Form closeForm={this.closeFormChild} dataStore={dataStore} parent_id={this.props.parent_id} refer_id={this.props.id} sendTo="2" /> : null}

        </div>

        const modtrue = <div className={styles.cmt_pv_komen} key={this.props.id}>
            { this.props.moderasi ? <div className={styles.cmt_title}>Komentar Anda dalam proses moderasi</div> : <div className={styles.cmt_mt15}></div> }
            <div className={styles.cmt_box}>
                <div className={styles.cmt_list_dk}>
                    <Comment_Profile_Image photo={this.props.image} mr10="false" nickname={this.props.nickname} />
                    <Comment_Username nickname={this.props.nickname} create_date={this.props.create_date} mb10="false" verified_user={typeof datastoresVerified[this.props.uniqueid] !== 'undefined'?datastoresVerified[this.props.uniqueid]:false} />
                    <div className={styles.cmt_dk_komen} style={{wordBreak:uaBreak}}>
                        {unescape(this.props.content)}
                    </div>
                </div>
            </div>
        </div>
        const final = this.props.mod ? modtrue : divelement
        return (
            <div className={styles.cmt_list_dk_sub+' '+anchorhighlightchild}  key={this.props.id} id={'cmt'+this.props.id}>
                { final  }
            </div>
        );
    }


    toanchor=()=>{

        this.props.openHide(true);
        this.props.dataStore.anchormaster = ''
        this.props.dataStore.anchor = this.props.refer_id

        setTimeout(()=>{
        var elems = document.querySelectorAll('.'+styles.cmt_highlight);
        [].forEach.call(elems, function(el) {
            el.classList.remove(styles.cmt_highlight);
        });this.props.refer_id
        var element = document.getElementById('cmt'+this.props.refer_id);

        element.classList.add(styles.cmt_highlight);
        this.props.dataStore.configKomentar.onscroll(this.props.refer_id)
        },500);

    }

    componentDidMount(){
        var anchor = this.props.dataStore.anchor
        if(anchor == ''){

        }
        else {
            this.props.dataStore.anchormaster = this.props.parent_id
            setTimeout(()=>{
            this.props.dataStore.configKomentar.onscroll(this.props.dataStore.anchor)
            },1000)
        }
    }
    closeFormChild=()=>{

        setTimeout(()=>{
            this.props.openHide()
            this.dispParent = false
        },1500)

        this.props.dataStore.configKomentar.onresize()
    }

    OpenForm=()=>{
        event.preventDefault();
        this.dispParent = !this.dispParent
        this.props.dataStore.configKomentar.onresize()
    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_row/comment_child_row.js